module.exports = __webpack_public_path__ + "img/41_49.24db1d9e.png";